
import { defineComponent } from 'vue';

/**
 * Icone de seta.
 * @displayName IconBack [Componente do UseIcon]
 */
export default defineComponent({
    name: 'IconBack',
    props: {
        size: {
            type: [String, Number],
            default: 22,
        },
        color: {
            type: String,
            default: 'white',
        },
    },
});
